import React, { useState } from 'react';
import { useAuth } from 'hooks';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const s3Bucket = process.env.REACT_APP_PORTAL_CDN || 'dev-scil-portal-cdn';
const baseLogoUrl = `https://${s3Bucket}.s3.eu-west-1.amazonaws.com/images/logos/accounts`;
function CustomerAccountLogo() {
  const { user } = useAuth();
  const [imageLoaded, setImageLoaded] = useState(false);
  if (!user.isPartnerAccount) return null;
  return (
    <Container>
      <img
        height={32}
        alt='Account Logo'
        src={`${
          baseLogoUrl.endsWith('/') ? baseLogoUrl.slice(0, -1) : baseLogoUrl
        }/${user.accountId}.png`}
        style={{ display: !imageLoaded ? 'none' : 'block' }}
        onLoad={() => setImageLoaded(true)}
        onError={() => setImageLoaded(false)}
      />
    </Container>
  );
}

CustomerAccountLogo.propTypes = {};

export default CustomerAccountLogo;
